import React from "react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from 'react-i18next';


import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import CheckIcon from '@mui/icons-material/Check';




export default function Menu(props) {
  	let navigate = useNavigate(); 

	const { t, i18n } = useTranslation("",{lng: props.language});

	const languages = [
	  { name: t("Deutsch") ,  iso: "de" , icon: <CheckIcon sx={{fontSize: '28px', color: 'white'}}/> },
	  { name: t("English"),  iso: "en" , icon: <CheckIcon  sx={{fontSize: '28px', color: 'white'}}/>},
	];
	
	const callUrl = (url) => {
		navigate(url);
	};

	const changeLanguage = (lng) => {
		i18n.changeLanguage(lng);
	};
	
  	return (<>
				<div class="navbar">
					<a class={props.logo == "logo-verkauf.png" ? "navbarHighlight" : ""} onClick={e => callUrl("/immobilienverkauf")}>{t("ImmobilienClaim1")}</a>
					<a class={props.logo == "logo-verwaltung.png" ? "navbarHighlight" : ""}onClick={e => callUrl("/immobilienverwaltung")}>{t("ImmobilienClaim2")}</a>
					<a class={props.logo == "logo-bewertung.png" ? "navbarHighlight" : ""} onClick={e => callUrl("/immobilienbewertung")}>{t("ImmobilienClaim3")}</a>

				</div>
			</>
	  )
}